import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "../../css/Carousel.css";
import { showPrice } from "../../utils/showPrice";
import Wishlisted from "../property/Wishlisted";
import { Link } from "react-router-dom";
import generateSlug from "../common/generateSlug";
import AlertModal from "../modals/AlertModal";
const AffordableProjects = ({
  title,
  affordableProjects,
  user,
  token,
  wishlist,
  handleDispatch,
  category,
}) => {
  const affordRef = useRef(null);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const handleOpenModal = () => {
    setShowAlertModal(true);

    // Auto close after 2 seconds
    setTimeout(() => {
      setShowAlertModal(false);
    }, 1500);
  };

  // Affordable Projects
  const affordpro = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 1000,
    autoplay: false,
    pauseOnHover: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    // prevArrow: <PrevArrow />,
    // nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };
  const handlePrevClick1 = () => {
    if (affordRef.current) {
      affordRef.current.slickPrev();
    }
  };
  const handleNextClick1 = () => {
    if (affordRef.current) {
      affordRef.current.slickNext();
    }
  };

  const affordprobg = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor: "rgb(47, 82, 148)",
  };

  const affordable = {
    buy: {
      link: "/buy/searches/flats-for-sale-in-jaipur-rajasthan-srcid-1",
      localStorageKey: "selectedItems:Price Asc",
    },
    rent: {
      link: "/rent/searches/flats-for-rent-in-jaipur-rajasthan-srcid-1",
      localStorageKey: "selectedItems:Price Asc",
    },
    plot: {
      link: "/buy/searches/plots-for-sale-in-jaipur-rajasthan-srcid-1",
      localStorageKey: "selectedItems:Price Asc",
      localStorageFeatures: "property_type:plot",
    },
  };
  const affordableStyles = affordable[category];

  //alert(JSON.stringify(affordableProjects));
  const handleLinkClick = (project) => {
    // alert(JSON.stringify(project));
    // let url = '';

    // url = `/${project?.property_service}-${project?.redirection}`

    const url = generateSlug(project);

    const propertyIds = project?.propertyIds;

    //   navigate(url, { state: { propertyIds }, replace: true });
    localStorage.setItem(
      "last-property-seen",
      JSON.stringify({ id: propertyIds, typeWithId: url })
    );

    window.location.href = url; // Navigate manually
  };

  return (
    <>
      {affordableProjects?.length > 0 && (
        <section className="afford-section sectiontopgap" style={{position:'relative'}}>
          <div className="container">
            <div className="affordable-header-container">
              <div className="sectiontitle section-title-text">
                <div className="titleunderline" data-aos="fade-right">
                  <svg
                    width="64"
                    height="3"
                    viewBox="0 0 64 3"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 1.5H62"
                      stroke="#F68633"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <h1>{title}</h1>
              </div>

              <div className="slider-controls">
                <button
                  className="slider-btn prev-btn affordable-prev-btn"
                  onClick={handlePrevClick1}
                >
                  ❮
                </button>
                <Link
                  to={affordableStyles.link}
                  onClick={() => {
                    if (affordableStyles.localStorageKey) {
                      localStorage.setItem(
                        "sort_clicked",
                        affordableStyles.localStorageKey
                      );
                    }
                    if (affordableStyles.localStorageFeatures) {
                      localStorage.setItem(
                        "feature_clicked",
                        affordableStyles.localStorageFeatures
                      );
                    }
                  }}
                >
                  <button className="view-all-btn">VIEW ALL</button>
                </Link>
                <button
                  className="slider-btn next-btn affordable-next-btn"
                  onClick={handleNextClick1}
                >
                  ❯
                </button>
              </div>
            </div>

            <div className="content content_margin">
              <Slider ref={affordRef} {...affordpro}>
                {affordableProjects?.length > 0 &&
                  affordableProjects?.map((affproject, index) => (
                    <Link
                      style={{ color: "#343434", textDecoration: "none" }}
                      onClick={() => handleLinkClick(affproject)}
                    >
                      <div className="affordslides ">
                        <div
                          className="affordbox"
                          style={{
                            ...affordprobg,
                            backgroundImage: `url(${affproject.images[0]})`,
                          }}
                        >
                          <div className="overlaydata">
                            <div className="primdata">
                              <div className="protop">
                                <div className="protitle">
                                  <h4 style={{ textTransform: "capitalize" }}>
                                    {affproject?.project_name ||
                                      `${affproject?.sizes?.[0]} Sq.Ft. ${affproject?.property_type}`}
                                  </h4>
                                </div>
                              </div>

                              <div className="primmid">
                                <p className="primloc">
                                  <svg
                                    width="8"
                                    height="14"
                                    viewBox="0 0 8 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4 0.888672C1.77778 0.888672 0 2.66645 0 4.88867C0 7.11089 4 13.3331 4 13.3331C4 13.3331 8 7.11089 8 4.88867C8 2.66645 6.22222 0.888672 4 0.888672ZM4 6.66645C3.02222 6.66645 2.22222 5.86645 2.22222 4.88867C2.22222 3.91089 3.02222 3.11089 4 3.11089C4.97778 3.11089 5.77778 3.91089 5.77778 4.88867C5.77778 5.86645 4.97778 6.66645 4 6.66645Z"
                                      fill="white"
                                    />
                                  </svg>
                                  <span>
                                    {affproject?.sub_locality_name},{" "}
                                    {affproject?.locality_name}
                                  </span>
                                </p>

                                <ul className="proul">
                                  {affproject?.types &&
                                    affproject?.types.length > 0 && (
                                      <li>
                                        {affproject?.types
                                          ?.filter(
                                            (value) =>
                                              value !== null && value !== ""
                                          )
                                          ?.map((value) =>
                                            value
                                              .toString()
                                              .replace(/_/g, " ")
                                              .slice(0, 5)
                                          ) // ✅ replace _ with space
                                          .join(", ")}{" "}
                                        {[
                                          "apartment",
                                          "villa",
                                          "independent_house",
                                          "independent_floor",
                                        ].includes(affproject?.property_type)
                                          ? `BHK ${affproject?.property_type.replace(
                                              /_/g,
                                              " "
                                            )}` // ✅ also replace _ in property_type
                                          : affproject?.property_type?.replace(
                                              /_/g,
                                              " "
                                            )}
                                      </li>
                                    )}

                                  {/* {affproject?.types != '' && (
                                  <li>{affproject?.types?.filter(value => value !== '')?.map(value => value.toString().slice(0, 5)).join(", ")} BHK {affproject?.property_type}</li>
                                )} */}
                                  {affproject?.sizes?.length > 0 && (
                                    <li style={{ textTransform: "capitalize" }}>
                                      {affproject.sizes.length === 1
                                        ? `${affproject.sizes[0]} SQ.FT ${
                                            affproject?.property_type ===
                                            "apartment"
                                              ? "(Built Up)"
                                              : `(${affproject?.property_type?.replace(
                                                  /_/g,
                                                  " "
                                                )})`
                                          }`
                                        : `${affproject.sizes[0]} - ${
                                            affproject.sizes[
                                              affproject.sizes.length - 1
                                            ]
                                          } SQ.FT ${
                                            affproject?.property_type ===
                                            "apartment"
                                              ? "(Built Up)"
                                              : ""
                                          }`}
                                    </li>
                                  )}

                                  {affproject?.amenities &&
                                    affproject.amenities.length > 0 &&
                                    affproject.amenities
                                      .slice(0, 3)
                                      .map((amenity, index) => (
                                        <li key={index}>{amenity.name}</li>
                                      ))}
                                </ul>
                              </div>

                              <div className="primbot">
                                <div className="primbotbox white-btnbox">
                                  <p className="d-flex align-center ">
                                    <span className="price_afford">
                                      {["rent"].includes(
                                        affproject?.property_service
                                      ) ? (
                                        <>
                                          <i className="fa fa-rupee"></i>{" "}
                                          {affproject?.property_price}
                                        </>
                                      ) : (
                                        showPrice(affproject?.property_price)
                                      )}
                                    </span>
                                  </p>
                                  <div className="proprice">
                                    <Wishlisted
                                      data={affproject}
                                      wishlist={wishlist}
                                      user={user}
                                      token={token}
                                      handleDispatch={handleDispatch}
                                      handleOpenModal={handleOpenModal}
                                      themeValue={"light"}
                                    />
                                    {/* <Link to="/">
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_992_347)">
                                          <path d="M7.05195 12.0066L6.1462 12.9201C5.93283 13.1374 5.69308 13.2946 5.43379 13.4016C5.04561 13.5612 4.61398 13.6042 4.20479 13.5266C3.79367 13.4489 3.40695 13.257 3.0842 12.9401C2.86986 12.7258 2.71311 12.4856 2.6047 12.2277C2.44504 11.8386 2.40158 11.4074 2.4792 10.9963C2.55683 10.5861 2.74923 10.1989 3.06758 9.87912L5.34933 7.56855C5.5627 7.35468 5.80295 7.19502 6.06223 7.09002C6.45139 6.9289 6.88158 6.88493 7.2922 6.96258C7.70333 7.04071 8.09004 7.23308 8.41136 7.55193C8.59008 7.72624 8.72726 7.92155 8.83029 8.13005C8.83958 8.13202 8.84739 8.13493 8.8547 8.1364C9.09348 8.18327 9.34836 8.15837 9.57198 8.06658C9.72823 8.00408 9.86886 7.9113 9.99045 7.78827L10.9157 6.86346C10.7082 6.48649 10.444 6.13349 10.1247 5.81755C9.67451 5.37518 9.15155 5.03824 8.59639 4.81755C7.76142 4.48552 6.8547 4.40643 5.98554 4.57877C5.11886 4.75212 4.28436 5.18083 3.61886 5.85662L1.33564 8.16527C0.890325 8.61449 0.554388 9.13646 0.3332 9.69358C0.00166899 10.5281 -0.077456 11.4348 0.094919 12.303C0.267763 13.1711 0.696982 14.0051 1.37323 14.6711C1.82148 15.1159 2.34539 15.4519 2.90108 15.6726C3.73554 16.0061 4.64229 16.0832 5.50995 15.9109C6.37811 15.7385 7.21211 15.3083 7.87861 14.634L10.1618 12.325C10.174 12.3127 10.1838 12.3006 10.1955 12.2883C10.1784 12.2908 10.1618 12.2956 10.1447 12.2981C9.1042 12.4997 8.03536 12.3986 7.05195 12.0066Z" fill="white" />
                                          <path d="M15.9087 3.72285C15.7422 2.8537 15.3164 2.01729 14.6455 1.34689C14.1997 0.900604 13.6777 0.560761 13.1235 0.337104C12.2905 -0.000801951 11.3847 -0.0838019 10.5151 0.0841668C9.64596 0.251636 8.80955 0.676948 8.13961 1.34685L5.84324 3.64373C5.82664 3.66082 5.80955 3.67985 5.79099 3.69745C5.79783 3.69745 5.80418 3.69548 5.81052 3.69548C6.85789 3.48551 7.93796 3.58317 8.93014 3.97967C8.93502 3.98017 8.93993 3.98407 8.94577 3.98554L9.86277 3.07001C10.0766 2.85567 10.3183 2.69892 10.5776 2.59345C10.9663 2.43476 11.3965 2.39617 11.8081 2.47479C12.2177 2.55439 12.603 2.74873 12.9238 3.07001C13.1377 3.28389 13.2939 3.5246 13.3989 3.78435C13.5576 4.17401 13.5976 4.60467 13.5185 5.01532C13.438 5.42498 13.2436 5.81073 12.9238 6.13104L10.6269 8.42645C10.4136 8.64079 10.1714 8.79754 9.91208 8.90351C9.5234 9.06123 9.09177 9.10029 8.68211 9.02167C8.27099 8.9411 7.88671 8.74726 7.56589 8.42645C7.39352 8.2531 7.2573 8.0622 7.15624 7.85664C7.14549 7.8542 7.13427 7.85076 7.12499 7.84979C6.88524 7.80439 6.62939 7.82929 6.40771 7.92207C6.25146 7.98701 6.1118 8.08076 5.99121 8.20282L5.07471 9.12957C5.27783 9.49626 5.53418 9.83954 5.84327 10.1486C6.29055 10.5964 6.81202 10.9352 7.36621 11.1603C8.19824 11.4977 9.10546 11.5807 9.97461 11.4123C10.8428 11.2448 11.6787 10.8205 12.3506 10.1486L14.6455 7.8532C15.0928 7.40642 15.4321 6.88495 15.6558 6.33073C15.9936 5.49826 16.0776 4.59201 15.9087 3.72285Z" fill="white" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_992_347">
                                            <rect width="16" height="16" fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </Link> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
              </Slider>
            </div>
          </div>
          {showAlertModal && <AlertModal />}
        </section>
      )}
    </>
  );
};

export default AffordableProjects;
